import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'clsx';
import React from 'react';

import styles from './Loading.scss';

interface LoadingProps {
  classes?: string;
}

const Loading: React.FC<LoadingProps> = ({ classes }) => (
  <CircularProgress color="inherit" className={classNames(styles.spinner, classes)} />
);

export default Loading;
